module.exports = __webpack_public_path__ + "static/media/myOrderActive.fc590ebf.svg";